import {createStore} from 'redux'
import mapReducer from './map.reducer'

const store = createStore(mapReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
window.store = store;
export default store;

